import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    margin: '0 auto',
    maxWidth: '500px',
  },
}));

export default useStyles;
